@if (record) {
  <letter-detail [flowId]="flowId" [record]="record | async" [offices]="offices | async"></letter-detail>
}